// GlobalErrorPopup.jsx
import React, { useEffect } from 'react';
import { useError } from '../../../context/ErrorContextProvider';
import './GlobalErrorPopup.css';

const GlobalErrorPopup = () => {
  const { error, isVisible, hideError } = useError();

  useEffect(() => {
    if (isVisible && error) {
      // Auto-hide success messages after 3 seconds
      if (error.type === 'success') {
        const timer = setTimeout(() => {
          hideError();
        }, 3000);
        
        return () => clearTimeout(timer);
      }
      
      // Auto-hide info messages after 4 seconds
      if (error.type === 'info') {
        const timer = setTimeout(() => {
          hideError();
        }, 4000);
        
        return () => clearTimeout(timer);
      }
    }
  }, [isVisible, error, hideError]);

  if (!error || !isVisible) return null;

  const getIcon = () => {
    switch (error.type) {
      case 'success':
        return (
          <svg className="popup-icon success-icon" viewBox="0 0 24 24" fill="none">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
          </svg>
        );
      case 'warning':
        return (
          <svg className="popup-icon warning-icon" viewBox="0 0 24 24" fill="none">
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="currentColor"/>
          </svg>
        );
      case 'info':
        return (
          <svg className="popup-icon info-icon" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor"/>
          </svg>
        );
      default:
        return (
          <svg className="popup-icon error-icon" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" fill="currentColor"/>
          </svg>
        );
    }
  };

  const getTitle = () => {
    switch (error.type) {
      case 'success':
        return 'Success';
      case 'warning':
        return 'Warning';
      case 'info':
        return 'Information';
      default:
        return 'Error';
    }
  };

  return (
    <div className={`global-error-overlay ${isVisible ? 'visible' : ''}`}>
      <div className={`global-error-popup ${error.type}`}>
        <div className="popup-header">
          {getIcon()}
          <h3 className="popup-title">{getTitle()}</h3>
          <button 
            className="popup-close-btn" 
            onClick={hideError}
            aria-label="Close"
          >
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <div className="popup-content">
          <p className="popup-message">{error.message}</p>
        </div>
        <div className="popup-footer">
          <button 
            className={`popup-btn ${error.type}`}
            onClick={hideError}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalErrorPopup;